<template>
    <common-dialog
        from="network"
        :is-special="true"
        width="362px"
        :show-search="false"
        :dialog-visible.sync="showServiceVisibe"
        @handleClose="handleClose"
    >
        <div class="network_tips">
            <img
                class="tips_serve"
                src="@/assets/withdraw/headset.png"
                alt=""
            />
            <div class="text-color font-16 text-center m-b-38 m-t-14">
                {{ contentText }}
            </div>
            <!-- <el-button
                class="confrim_btn common_btn"
                @click="buyCoinsKYC"
            >
                {{ $t('message.common.confirm') }}
            </el-button> -->
            <div class="flex">
                <el-button
                    v-for="(item, index) in serviceArr"
                    :key="index"
                    class="confrim_btn common_btn"
                    @click="itemClick(item)"
                >
                    {{ item.name }}
                </el-button>
            </div>
        </div>
    </common-dialog>
</template>

<script>
import CommonDialog from '@/components/commomDialog';
import { isHttpUrl, openLinkInHiddenWindow } from '@/utils';
import { mapState } from 'vuex';
import { getToken } from '@/utils/auth';
export default {
    name: 'CustomerDialog',
    components: {
        CommonDialog
    },
    props: {
        showServiceVisibe: {
            type: Boolean,
            default: false
        },
        contentText: {
            type: String,
            default() {
                return this.$t('home_service_modal_tips');
            }
        }
    },
    data() {
        return {
            openLinkInHiddenWindow
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.user_info
        }),
        serviceArr() {
            const { service_link } = this.userInfo;
            const defaultArr = [
                {
                    name: `${this.$t('customer_service')}`,
                    service_link: ''
                }
            ];

            if (!service_link) return defaultArr;

            const arr = service_link.split(',');
            const result = arr.map((e, index) => {
                const num = index + 1;
                return {
                    name: `${this.$t('customer_service')} ${num}`,
                    service_link: e
                };
            });
            return result;
        }
    },
    mounted() {},
    methods: {
        itemClick(item) {
            const { service_link } = item;
            // const isComplete = isHttpUrl(service_link);
            // if (!service_link || !isComplete) {
            //     // uni.$u.toast(this.$t('tv_fingerprint_recognition_exception'));
            //     return;
            // }

            this.handleClose();
            // location.href = service_link;
            // window.open(service_link, '_blank');
            this.openLinkInHiddenWindow(service_link);
        },
        handleClose() {
            this.$emit('update:showServiceVisibe');
            this.$emit('onClose');
        },
        buyCoinsKYC() {
            if (!getToken()) {
                this.$router.push({
                    path: '/login',
                    query: { redirect: '/buy/custorm' }
                });
                this.$emit('update:showServiceVisibe');
                return;
            }
            // const { service_link } = this.userInfo;
            // const firstLink = service_link.split(',')[0];
            // const isComplete = isHttpUrl(firstLink);
            // if (firstLink && isComplete) {
            //     this.openLinkInHiddenWindow(firstLink);
            this.$emit('update:showServiceVisibe');
            // }
            this.$emit('confirm');
        }
    }
};
</script>

<style lang="scss" scoped>
.tips_serve {
    width: 50px;
    height: 50px;
}
.network_tips {
    padding: 0 40px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tips_logo {
        width: 60px;
        height: 60px;
        margin-bottom: 40px;
    }
    .tips_text {
        font-size: 14px;
        color: $basicWhite;
        margin-bottom: 40px;
        text-align: left;
        line-height: 20px;
        font-family: 'PingFang_Regular';
    }
    .confrim_box {
        width: 100%;
    }
    .confrim_btn {
        width: 100%;
        height: 40px !important;
        background-color: $basicColor;
        border-radius: 4px;
        padding: 12px 0;
        font-size: 12px;
        font-weight: 500;
        color: #0b0e11;
        min-width: 150px;
        & > span {
            font-family: 'PingFang_Medium' !important;
        }
    }
}
</style>
